const routes = [
  {
    path: '/activity',
    name: '',
    redirect:'/activity/list'
  },
  {
    path: '/activity/list',
    name: '',
    meta:{
      module:'operate_manage',
      menu:'/activity/list',
      title:'联盟活动',
      keepAlive: true,
      breadcrumb:['activity'],
      menuBreadcrumb: 'activity',
    },//menu 用于所属右侧菜单栏
    component: () => import('@/views/activity/list.vue'),
  },
  {
    path: '/activity/info',
    name: '',
    meta:{
      module:'operate_manage',
      menu:'/activity/list',
      title:'联盟活动',
      breadcrumb:['activity','info'],
      menuBreadcrumb: 'info',
    },//menu 用于所属右侧菜单栏,breadcrumb用于面包屑
    component: () => import('@/views/activity/info.vue'),
  },
]

export default routes;
